<div class="card">
  <section class="name-remote">
    <div
      class="patient-name"
      (click)="changePatient()"
      [matTooltip]="
        appointment.patient_first_name + ' ' + appointment.patient_last_name
      "
    >
      <span>{{ appointment.patient_first_name }}</span>
      <span>{{ appointment.patient_last_name }}</span>
    </div>
    <div class="remote-time">
      @if (appointment.is_remote) {
        <span> Videochiamata</span>
      }
    </div>
  </section>
  <div class="time">
    <span>{{ appointment.start_time }}</span>
  </div>
</div>
